import React from "react";
import { useContent } from "@/lib/content";
import { useTheme } from "@/components/ThemeProvider";
import PilotForm from "@/components/PilotForm";

export default function Connect() {
    const { content } = useContent();
    const { theme } = useTheme();
    const v = (k, fb = "") => content[k] || fb;
    const conciergePhoneDisplay = theme.phone_display || "+91 97399 08844";
    const conciergePhoneRaw = (theme.phone_number || "+919739908844").replace(/[^\d]/g, "");

    return (
        <>
            <section className="pt-40 md:pt-48 pb-16" data-testid="connect-hero">
                <div className="container-prose grid md:grid-cols-12 gap-12 items-end">
                    <div className="md:col-span-7">
                        <p className="eyebrow">Connect</p>
                        <h1 className="font-serif text-5xl md:text-[72px] leading-[1.04] mt-6 reveal">
                            For evaluation conversations, write to us — <span className="italic text-[hsl(var(--brass))]">we reply within one working day</span>.
                        </h1>
                    </div>
                    <p className="md:col-span-5 text-[16px] md:text-[18px] leading-relaxed text-[hsl(var(--ink))] reveal" style={{ animationDelay: "0.15s" }}>
                        We take a small number of senior conversations every quarter. If you would like one of those, this is the door. We will reply within one working day.
                    </p>
                </div>
            </section>

            <section className="section-tight" data-testid="connect-channels">
                <div className="container-prose">
                    <div className="grid md:grid-cols-3 gap-10">
                        {[
                            {
                                k: "Email",
                                v: v("contact_email", "enquiries@lesconcierges.co.in"),
                                href: `mailto:${v("contact_email", "enquiries@lesconcierges.co.in")}`,
                                tid: "channel-email",
                            },
                            {
                                k: "WhatsApp",
                                v: conciergePhoneDisplay,
                                href: `https://wa.me/${conciergePhoneRaw}`,
                                tid: "channel-whatsapp",
                            },
                            {
                                k: "Offices",
                                v: "Bangalore HQ · India offices · 150 countries via partners",
                                href: null,
                                tid: "channel-office",
                            },
                        ].map((c) => (
                            <div key={c.k} className="persona-card" data-testid={c.tid}>
                                <p className="eyebrow">{c.k}</p>
                                {c.href ? (
                                    <a
                                        href={c.href}
                                        target={c.href.startsWith("http") ? "_blank" : undefined}
                                        rel="noreferrer"
                                        className="font-serif text-2xl md:text-[28px] mt-4 inline-block hover:text-[hsl(var(--brass))] transition-colors"
                                    >
                                        {c.v}
                                    </a>
                                ) : (
                                    <p className="font-serif text-2xl md:text-[28px] mt-4">{c.v}</p>
                                )}
                                {c.alt && (
                                    <a
                                        href={c.alt.href}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="font-serif text-[18px] md:text-[20px] mt-3 inline-block hover:text-[hsl(var(--brass))] transition-colors"
                                        style={{ color: "hsl(var(--muted))" }}
                                        data-testid={`${c.tid}-alt`}
                                    >
                                        {c.alt.v}
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="section" style={{ background: "hsl(var(--cream))" }} data-testid="connect-form">
                <div className="container-prose max-w-4xl">
                    <p className="eyebrow text-center">A private pilot</p>
                    <h2 className="font-serif text-4xl md:text-5xl mt-6 leading-tight text-center">
                        Tell us where you are. We will come to you.
                    </h2>
                    <div className="mt-12">
                        <PilotForm
                            invitation={v("form_invitation")}
                            whatsappAlt={v("whatsapp_alt")}
                            whatsappNumber={v("whatsapp_number", "919739908844")}
                        />
                    </div>
                </div>
            </section>
        </>
    );
}
